var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1C26.1982 5.59239 32.9826 7.98348 39.9159 7.66667C40.9253 11.0956 41.2342 14.6921 40.8242 18.2426C40.4141 21.7931 39.2935 25.225 37.529 28.3345C35.7644 31.444 33.3919 34.1675 30.5524 36.3433C27.713 38.5191 24.4645 40.1027 21 41C17.5355 40.1027 14.287 38.5191 11.4476 36.3433C8.60809 34.1675 6.23559 31.444 4.47104 28.3345C2.70648 25.225 1.58589 21.7931 1.17584 18.2426C0.76579 14.6921 1.07465 11.0956 2.08408 7.66667C9.01738 7.98348 15.8018 5.59239 21 1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 21C22.2887 21 23.3334 19.9554 23.3334 18.6667C23.3334 17.378 22.2887 16.3334 21.0001 16.3334C19.7114 16.3334 18.6667 17.378 18.6667 18.6667C18.6667 19.9554 19.7114 21 21.0001 21Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21V26.8333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.e8b47f4e.svg";
export { ForwardRef as ReactComponent };